export class CharacterTextureError extends Error {}
